import { render, staticRenderFns } from "./WebRtc.vue?vue&type=template&id=1df840e4&scoped=true&"
import script from "./WebRtc.vue?vue&type=script&lang=js&"
export * from "./WebRtc.vue?vue&type=script&lang=js&"
import style0 from "./WebRtc.vue?vue&type=style&index=0&id=1df840e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df840e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1df840e4')) {
      api.createRecord('1df840e4', component.options)
    } else {
      api.reload('1df840e4', component.options)
    }
    module.hot.accept("./WebRtc.vue?vue&type=template&id=1df840e4&scoped=true&", function () {
      api.rerender('1df840e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/control/WebRtc.vue"
export default component.exports